import { useCallback, useEffect, useState } from 'react';
import { galleryImages } from '@/mocks/wedding';

const PANEL_BG =
  'https://readdy.ai/api/search-image?query=Warm%20moody%20still%20life%20of%20a%20cream%20rose%20bridal%20bouquet%20and%20dried%20grass%20on%20a%20dark%20walnut%20table%2C%20soft%20cinematic%20light%2C%20deep%20shadows%2C%20muted%20warm%20brown%20tones&width=2400&height=1350&seq=wed-panel-gallery&orientation=landscape';

export default function GalleryPanel() {
  const [active, setActive] = useState<number | null>(null);

  const close = useCallback(() => setActive(null), []);
  const step = useCallback((dir: number) => {
    setActive((cur) => {
      if (cur === null) return cur;
      const next = (cur + dir + galleryImages.length) % galleryImages.length;
      return next;
    });
  }, []);

  useEffect(() => {
    if (active === null) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowRight') step(1);
      if (e.key === 'ArrowLeft') step(-1);
    };
    addEventListener('keydown', onKey);
    return () => removeEventListener('keydown', onKey);
  }, [active, close, step]);

  const current = active === null ? null : galleryImages[active];

  return (
    <section className="panel gallery-panel" id="gallery">
      <img className="panel-bg" src={PANEL_BG} alt="" aria-hidden="true" data-parallax="0.32" />
      <div className="panel-veil gallery-veil" aria-hidden="true" />

      <div className="gallery-head">
        <p className="stamp" data-reveal>
          04 — 웨딩 갤러리
        </p>
        <h2 data-reveal>
          우리의 순간을
          <br />
          <em className="accent">한 장씩</em> 모았습니다
        </h2>
        <p className="sub" data-reveal>
          사진을 클릭하면 크게 볼 수 있습니다. 좌우 방향키로 넘겨 보세요.
        </p>
      </div>

      <div className="gallery-grid">
        {galleryImages.map((img, i) => (
          <button
            key={img.id}
            type="button"
            className="gallery-item"
            data-reveal
            aria-label={`${img.alt} 크게 보기`}
            onClick={() => setActive(i)}
          >
            <img src={img.src} alt={img.alt} title={`${img.alt} — 도윤 서연 웨딩 사진`} />
            <span className="zoom-badge" aria-hidden="true">
              <i className="ri-zoom-in-line" />
            </span>
          </button>
        ))}
      </div>

      {current ? (
        <div className="lightbox" role="dialog" aria-modal="true" aria-label="사진 크게 보기">
          <button type="button" className="lightbox-close" aria-label="닫기" onClick={close}>
            <i className="ri-close-line" aria-hidden="true" />
          </button>
          <button type="button" className="lightbox-nav prev" aria-label="이전 사진" onClick={() => step(-1)}>
            <i className="ri-arrow-left-s-line" aria-hidden="true" />
          </button>
          <img src={current.src} alt={current.alt} />
          <button type="button" className="lightbox-nav next" aria-label="다음 사진" onClick={() => step(1)}>
            <i className="ri-arrow-right-s-line" aria-hidden="true" />
          </button>
          <span className="lightbox-count">
            {(active ?? 0) + 1} / {galleryImages.length}
          </span>
        </div>
      ) : null}
    </section>
  );
}